import {
  cancelled,
  put,
  call,
  all,
  takeLatest,
} from 'redux-saga/effects'

import {
  updateTablesAction,
} from 'containers/Entity/actions'
import {
  get,
} from 'helpers/RequestUtil'
import {
  FETCH_WORKFLOW_HISTORY,
  FETCH_APPROVER_HISTORY,
  FETCH_HISTORY,
} from './constants'
import {
  clearWorkflowHistory,
  updateApproverHistory,
  updateWorkflowHistory,
  fetchWorkflowHistoryStart,
  fetchWorkflowHistorySuccess,
  fetchWorkflowHistoryError,
  fetchApproverHistoryStart,
  fetchApproverHistorySuccess,
  fetchApproverHistoryError,
  startFetchApproverHistoryAsync,
  startFetchWorkflowHistoryAsync,
} from './actions'

function* getApproverHistory(workflowId) {
  try {
    yield put(startFetchApproverHistoryAsync())
    yield put(fetchApproverHistoryStart())
    const data = yield call(get, `/api/fulcrum/workflows/${workflowId}/approver_histories`)
    const { result: { workflow_approver_histories } } = data
    yield put(updateTablesAction(data))
    yield put(fetchApproverHistorySuccess(workflow_approver_histories))
    return workflow_approver_histories
  } catch (error) {
    yield put(fetchApproverHistoryError(error))
  } finally {
    if (yield cancelled()) {
      yield put(clearWorkflowHistory())
    }
  }
}

function* getWorkflowHistory(workflowId) {
  try {
    yield put(startFetchWorkflowHistoryAsync())
    yield put(fetchWorkflowHistoryStart())
    const data = yield call(get, `/api/fulcrum/workflows/${workflowId}/histories`)
    const { result: { workflow_histories } } = data
    yield put(updateTablesAction(data))
    yield put(fetchWorkflowHistorySuccess(workflow_histories))
    return workflow_histories
  } catch (error) {
    yield put(fetchWorkflowHistoryError(error))
  } finally {
    if (yield cancelled()) {
      yield put(clearWorkflowHistory())
    }
  }
}

function* fetchWorkflowHistory(workflowId) {
  const history = yield call(getWorkflowHistory, workflowId)
  yield put(updateWorkflowHistory(history))
}

function* fetchApproverHistory(workflowId) {
  const history = yield call(getApproverHistory, workflowId)
  yield put(updateApproverHistory(history))
}

function* fetchHistory(workflowId) {
  yield all([
    call(fetchWorkflowHistory, workflowId),
    //call(fetchApproverHistory, workflowId),
  ])
}

function* fetchHistoryHandler(action) {
  const { workflowId } = action
  yield call(fetchHistory, workflowId)
}

function* watchFetchWorkflowHistory() {
  yield takeLatest(FETCH_WORKFLOW_HISTORY, fetchWorkflowHistory)
}

function* watchFetchApproverHistory() {
  yield takeLatest(FETCH_APPROVER_HISTORY, fetchApproverHistory)
}

function* watchFetchHistory() {
  yield takeLatest(FETCH_HISTORY, fetchHistoryHandler)
}

export {
  watchFetchHistory,
  fetchHistory,
}
